import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UtilitiesService } from '../../../common/shared/services/utilities.service';
import { Contact } from '../../../common/models/contact';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PersonalDataService {

  constructor(private _httpClient: HttpClient, private _utilitiesService: UtilitiesService) { }

  loadContact(): Observable<Contact> {
    return this._httpClient.get<Contact>(this._utilitiesService.getAPIUrl() + 'Contact', this._utilitiesService.httpConfig);
  }

  updateContact(contact: Contact): Observable<any> {
    return this._httpClient.patch(this._utilitiesService.getAPIUrl() + 'Contact', contact, this._utilitiesService.httpConfig);
  }
}